import React, { useEffect, useRef, useState } from "react";
import { Notifytext } from "./TextsStyled";
import { ReactComponent as UpSVG } from "../../assets/svg/icons/hi.svg";

interface NOTIFY_PROPS {
  text: string;
  time?: number;
  position?: "top" | "bot";
  fadeIn?: boolean;
  color?: string;
}
export default function NotifyText({
  text,
  position,
  fadeIn,
  color,
}: NOTIFY_PROPS) {
  const [showContent, setShowContent] = useState<any>(fadeIn);
  const [showContentFadeout, setShowContentFadeout] = useState<any>(false);

  useEffect(() => {
    setShowContent(fadeIn);
  }, [fadeIn]);

  const notificationTimeOut: any = useRef();

  useEffect(() => {
    if (showContent) {
      setShowContentFadeout(true);
      clearTimeout(notificationTimeOut.curent);
      notificationTimeOut.current = setTimeout(() => {
        setShowContentFadeout(false);
      }, 1666);
    } else {
      clearTimeout(notificationTimeOut.current);
      setShowContentFadeout(false);
    }
  }, [showContent]);
  return (
    <Notifytext
      fadeIn={showContentFadeout}
      textColor={color}
      position={position}
    >
      <UpSVG /> <p>{text}</p> <UpSVG />
    </Notifytext>
  );
}
